import { type CommonTranslationFunction } from '../../context';

export const getFilterDimensionTranslations = (
  common: CommonTranslationFunction,
) =>
  ({
    // product filters
    products: common('filters.products'),
    departments: common.withCustomer('filters.$department', {
      context: 'plural',
    }),
    sub_departments: common.withCustomer('filters.$sub-department', {
      context: 'plural',
    }),
    styles: common.withCustomer('filters.$styles'),
    brands: common('filters.brands'),
    events: common.withCustomer('filters.$events'),
    seasons: common('filters.seasons'),
    genders: common.withCustomer('filters.$genders'),
    collection_types: common('filters.collection-types'),
    manufacturers: common('scope.manufacturers'),
    classes: common.withCustomer('scope.$classes'),
    sub_classes: common.withCustomer('scope.$sub-classes'),
    product_groups: common.withCustomer('filters.$product-groups'),

    // geography filters
    locations: common('filters.locations'),
    regions: common.withCustomer('filters.$region', { context: 'plural' }),
    countries: common('filters.countries'),
    location_types: common('filters.location-types'),
    territories: common.withCustomer('filters.$territory', {
      context: 'plural',
    }),

    // location cluster filters
    location_clusters: common.withCustomer('filters.$location-clusters'),

    // sku filters
    sizes: common('filters.size'),

    // rebalancing to and from locations
    to_locations: common('filters.to-location', { context: 'plural' }),
    to_countries: common('filters.to-country', { context: 'plural' }),
    from_locations: common('filters.from-location', { context: 'plural' }),
    from_countries: common('filters.from-country', { context: 'plural' }),
  }) as const;
